(function() {
  "use strict";

  angular.module("app").directive("cccAssetMap", cccAssetMap);

  function cccAssetMap() {
    return {
      restrict: "EA",
      scope: false,
      controller: "AssetMapController"
    };
  }
})();
